import MWS from '../../utils/config/MWS';
import IWOS from '../../utils/config/IWOS';
import AWARE from '../../utils/config/AWARE';

const configMap = {
	MWS,
	IWOS,
	AWARE,
};

export default configMap;